import { render, staticRenderFns } from "./OrganizationPaymentMethods.vue?vue&type=template&id=5013e523"
import script from "./OrganizationPaymentMethods.vue?vue&type=script&lang=js"
export * from "./OrganizationPaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./OrganizationPaymentMethods.vue?vue&type=style&index=0&id=5013e523&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports